(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-Main-Banner"] && !Shopify.designMode) return;
  try {
    

  document.getElementById('play-video-button').addEventListener('click', function() {
    var popup = document.getElementById('video-popup');
    var video = popup.querySelector('video');
    
    popup.style.display = 'block';
    
    if (video) {
        video.play();
    }
});

document.getElementById('close-popup-button').addEventListener('click', function() {
    var popup = document.getElementById('video-popup');
    var video = popup.querySelector('video');
    
    if (video) {
        video.pause();
    }
    
    popup.style.display = 'none';
});

// Close popup when clicking outside the content
window.addEventListener('click', function(event) {
    var popup = document.getElementById('video-popup');
    if (event.target == popup) {
        var video = popup.querySelector('video');
        
        if (video) {
            video.pause();
        }
        
        popup.style.display = 'none';
    }
});


  } catch(e) { console.error(e); }
})();
})();
